<div [formGroup]="formGroup">
	<nc-toggle-buttons [formGroup]="formGroup" [options]="messageTypes" formControlName="absenceCaseType"> </nc-toggle-buttons>
</div>
